import React from 'react';

import styles from './monitoringErrorMetrics.module.scss';
import cn from 'classnames';
import Icon from '../icon/icon';

const MonitoringErrorMetrics = () => {
  const errors = [
    {
      description: 'Aktyvacijos / Deaktyvacijos nepavyko',
      count: 0,
      icon: 'hard_drives',
    },
    {
      description: 'Nepavykusios tranzakcijos',
      count: 3,
      icon: 'cardholder',
    },
    {
      description: 'Kitos problemos',
      count: 12,
      icon: 'warning',
    },
  ];
  return (
    <div className={styles.errorMetricsContainer}>
      {errors.map(error => (
        <div key={error.description} className={styles.errorMetricCard}>
          <div className="metric-card-header">
            <span
              className={cn('metric-card-count', {
                'no-errors': error.count === 0,
              })}
            >
              {error.count}
            </span>
            <Icon name={error.icon} />
          </div>
          <h4 className="metric-card-description">{error.description}</h4>
        </div>
      ))}
    </div>
  );
};

export default MonitoringErrorMetrics;
